/**
 * userPhone模块接口列表
 */
 import $http from '../utils/http'// 导入http中创建的axios实例

 const userPhone = {
   // 检查至少有一人绑定过电话
   checkContactPhone (params) {
     return $http.post(`${global.API_URL}/sme/contact/checkContactPhone`, params)
   }
 };
 
 export default userPhone
 


// WEBPACK FOOTER //
// ./src/api/userPhone.js